/* Cali Raised LED - two-line add-on variant picker (Option C). 2026-08-11.
 * Paired with crled-addon-picker.css; see the header there for the full design and
 * the DO-NOT-MOVE-THE-SELECT constraint (items[][id]/items[][quantity] pair by
 * form order). The select is never moved or wrapped - a face <span> is inserted as
 * a sibling BEFORE it, and CSS turns the select into an invisible overlay.
 *
 * Option text format: "NAME - $PRICE / SKU" (NAME itself may contain " - ", so the
 * regex is greedy up to the LAST " - $"). Options that don't match (no price)
 * render as wrapped raw text - still nothing clipped.
 */
(function () {
  'use strict';
  var SEL = '.group-product select.group-product-variant-option';

  function parse(text) {
    var m = String(text).trim().match(/^(.*)\s[-–—]\s*(\$[\d,.]+)(?:\s*\/\s*(.+))?$/);
    if (!m) return { name: String(text).trim(), price: '', sku: '' };
    return { name: m[1].trim(), price: m[2], sku: (m[3] || '').trim() };
  }

  function render(sel) {
    var wrap = sel.closest('.variant-select') || sel.parentElement;
    var face = wrap.querySelector('.crled-ap__face');
    if (!face) return;
    var o = sel.options[sel.selectedIndex];
    var p = parse(o ? o.text : '');
    face.innerHTML =
      '<span class="crled-ap__body"><span class="crled-ap__name"></span>' +
      '<span class="crled-ap__meta"><strong class="crled-ap__price"></strong>' +
      '<span class="crled-ap__sku"></span></span></span>' +
      '<span class="crled-ap__caret" aria-hidden="true">&#9662;</span>';
    face.querySelector('.crled-ap__name').textContent = p.name;
    face.querySelector('.crled-ap__price').textContent = p.price;
    face.querySelector('.crled-ap__sku').textContent = p.sku ? ' · ' + p.sku : '';
    if (!p.price) face.querySelector('.crled-ap__meta').style.display = 'none';
  }

  function refreshAll() {
    document.querySelectorAll(SEL).forEach(render);
  }

  function enhance(sel) {
    if (sel.dataset.crledAp) return;
    // Only enhance selects that live in the expected wrapper; anything unusual is
    // left native rather than risked.
    var wrap = sel.closest('.variant-select');
    if (!wrap) return;
    sel.dataset.crledAp = '1';
    var face = document.createElement('span');
    face.className = 'crled-ap__face';
    wrap.insertBefore(face, sel); // sibling before the select; the select never moves
    wrap.classList.add('crled-ap-on');
    render(sel);
  }

  function init() {
    document.querySelectorAll(SEL).forEach(enhance);
  }

  // A shopper picking an option fires change on the real select.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(SEL)) render(e.target);
  });
  // The theme also syncs selects PROGRAMMATICALLY (initSyncFromFirstGroup in
  // product-form.js territory), which fires no change event - cheaply re-read all
  // faces shortly after any interaction inside the group block.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.group-product')) {
      setTimeout(refreshAll, 80);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('load', function () { init(); refreshAll(); });
})();
